import { Grid, Typography } from '@mui/material';
import React from 'react';
import useOptInDialogStyles from '../../styles/opt-in/opt-in-dialog.style';
import FullScreenDialog from '../dialog';

type OptInDialogProps = {
    children: React.ReactNode;
    title: string;
    open: boolean;
    onClose: () => void;
    imgSrc?: string;
    description?: string;
};

export function OptInDialog(props: OptInDialogProps) {
    const classes = useOptInDialogStyles();

    return (
        <FullScreenDialog
            open={props.open}
            onClose={props.onClose}
            size={'small'}
        >
            {props.imgSrc && (
                <img
                    className={classes.image}
                    src={`/static/images/` + props.imgSrc}
                    alt="Wearable"
                />
            )}
            <div className={classes.dialogContent}>
                <Grid container spacing={4}>
                    <Grid item xs={12}>
                        <Grid item xs={12}>
                            <Typography
                                align="center"
                                variant="h3"
                                className={classes.title}
                            >
                                {props.title}
                            </Typography>
                            {props.description && (
                                <Typography
                                    align="center"
                                    variant="body1"
                                    className={classes.description}
                                >
                                    {props.description}
                                </Typography>
                            )}
                        </Grid>
                    </Grid>
                    {props.children}
                </Grid>
            </div>
        </FullScreenDialog>
    );
}
